import React, { useState, useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import { Input, Button } from 'antd';
import { EditFilled } from '@ant-design/icons';
import { useQuery } from 'hooks/apollo';

import Page from 'components/Page';
import Table from 'components/Table';

import globalMessages from 'translations/messages';
import useQueryParams from 'hooks/useQueryParams';
import messages from './messages';

import flaggedCommentsQuery from './flaggedComments.gql';
import RedactPersonalInfo from './RedactPersonalInfo';

const FlaggedComments = () => {
  const params = useQueryParams();
  const [search, setSearch] = useState();
  const [editFlaggedCommentId, setEditFlaggedCommentId] = useState();
  const surveyGroupId = params.get('surveyGroupId') || undefined;
  const { data, loading, refetch } = useQuery(flaggedCommentsQuery, { variables: { surveyGroupId }, fetchPolicy: 'cache-first' });

  const dataSource = useMemo(() => (data?.flaggedComments || []).map(fc => ({
    id: fc.id,
    respondedAt: fc.questionResponse.surveyResponse.respondedAt,
    customer: fc.questionResponse.surveyResponse.survey.customer.name,
    survey: fc.questionResponse.surveyResponse.survey.title,
    question: fc.questionResponse.question.title,
    meta: fc.meta,
  })), [data?.flaggedComments]);

  const columns = [
    {
      dataIndex: 'respondedAt',
      title: <FormattedMessage {...globalMessages.date} />,
      type: 'relativeDate',
      defaultSortOrder: 'descend',
    },
    {
      dataIndex: 'customer',
      title: <FormattedMessage {...globalMessages.customer} />,
    },
    {
      dataIndex: 'survey',
      title: <FormattedMessage {...globalMessages.survey} />,
    },
    {
      dataIndex: 'question',
      title: <FormattedMessage {...globalMessages.question} />,
      render: question => <span dangerouslySetInnerHTML={{ __html: question }} />,
    },
    {
      dataIndex: 'meta',
      title: 'Personal data',
      render: meta => meta.map(m => m.value).join(', '),
      search: (meta, s) => meta.find(m => m.value.toLowerCase().search(s) !== -1),
    },
  ];

  const actions = (comment) => (
    <Button icon={<EditFilled />} onClick={() => setEditFlaggedCommentId(comment.id)}>
      <FormattedMessage {...messages.resolve} />
    </Button>
  );

  const onDone = (next) => {
    if (next) {
      const nextComment = dataSource.find((fc, i) => i > 0 && dataSource[i - 1].id === editFlaggedCommentId);
      setEditFlaggedCommentId(nextComment?.id);
    } else {
      setEditFlaggedCommentId(false);
      refetch();
    }
  };

  return (
    <Page>
      <Page.Header title={<FormattedMessage {...messages.flaggedComments} />} />
      <Page.Content>
        <Input.Search onSearch={setSearch} allowClear placeholder="Search" style={{ marginBottom: '1em' }} />
        <Table
          loading={loading}
          columns={columns}
          dataSource={dataSource}
          search={search}
          actions={actions}
        />
        {editFlaggedCommentId
          && (
          <RedactPersonalInfo
            onDone={onDone}
            id={editFlaggedCommentId}
          />
          )}
      </Page.Content>
    </Page>
  );
};

export default FlaggedComments;
